import { uploadData } from 'aws-amplify/storage';
import { env } from './utils';
import { reportErrorToSentry } from './reportToSentry';

const uploadAWSS3File = async (
  file: any,
  fileKey: string,
  fileType: string,
  level: string,
): Promise<any> => {
  try {
    await uploadData({
      path: `public/${fileKey}`,
      data: file,
      options: { contentType: fileType },
    }).result;

    return `https://${env('RIVER_AWS_BUCKET_NAME')}/${level}/${fileKey}`;
  } catch (error) {
    reportErrorToSentry(error, {
      clientAction: 'User (Provider) tried uploading an image. Error in *uploadAWSS3File.ts*',
    });
    return undefined;
  }
};

export default uploadAWSS3File;
